import { connect } from 'react-redux'
import { PlayerBox } from '../components'

const mapStateToProps = (state, ownProps) => {
  const { language } = state.user
  return ({
    language,
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PlayerBox)


// WEBPACK FOOTER //
// ./src/Pages/Game/containers/PlayerBox.js